import { Box, FileIcon, Stack, Tooltip, useTheme } from "@compass/core";
import DvrIcon from "@mui/icons-material/Dvr";

export type ReportOutputFormat = "on-screen" | "pdf" | "direct-pdf" | "excel";

export const ReportOutputFormats = (props: { formats: ReportOutputFormat[] }) => {
  const generateTypeSize = "20px";

  return (
    <Stack position="relative" direction="row" spacing="md" alignItems={"center"} top="2px">
      {props.formats.includes("on-screen") && (
        <Tooltip title="This report can be generated on screen">
          <Box width={generateTypeSize} fontSize={generateTypeSize}>
            <DvrIcon fontSize="inherit" />
          </Box>
        </Tooltip>
      )}

      {props.formats.includes("pdf") && (
        <Tooltip title="This report can be generated with a PDF">
          <Box width={generateTypeSize}>
            <FileIcon fileName=".pdf" />
          </Box>
        </Tooltip>
      )}

      {props.formats.includes("direct-pdf") && (
        <Tooltip title="This report will be directly opened in PDF">
          <Box width={generateTypeSize}>
            <FileIcon fileName=".pdf" />
          </Box>
        </Tooltip>
      )}

      {props.formats.includes("excel") && (
        <Tooltip title="This report can be generated on with EXCEL">
          <Box width={generateTypeSize}>
            <FileIcon fileName=".xlsx" />
          </Box>
        </Tooltip>
      )}
    </Stack>
  );
};
